import styled from 'styled-components';
import * as MUI from '@material-ui/core';
import * as React from 'react';
import { theme } from '../../utils/theme';

export interface IconButtonProps extends MUI.IconButtonProps {
  tooltip?: string;
}

export const StyledIconButton = styled(MUI.IconButton)(props => ({
  "&:hover": {
    color: theme(props).palette.primary.main,
  },
  height: 'fit-content',
})) as React.FC<IconButtonProps>;

export const IconButton = (props: IconButtonProps) => {
  const {tooltip = "", ...btnProps} = props;
  return <MUI.Tooltip title={tooltip}>
    <StyledIconButton {...btnProps} />
  </MUI.Tooltip>
};